(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modelosdeimpresora', {
            parent: 'entity',
            url: '/modelosdeimpresora',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.modelosdeimpresora.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresoras.html',
                    controller: 'ModelosdeimpresoraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelosdeimpresora');
                    $translatePartialLoader.addPart('protocolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modelosdeimpresora-detail', {
            parent: 'modelosdeimpresora',
            url: '/modelosdeimpresora/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.modelosdeimpresora.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-detail.html',
                    controller: 'ModelosdeimpresoraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelosdeimpresora');
                    $translatePartialLoader.addPart('protocolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Modelosdeimpresora', function($stateParams, Modelosdeimpresora) {
                    return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modelosdeimpresora',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modelosdeimpresora-detail.edit', {
            parent: 'modelosdeimpresora-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modelosdeimpresora.new', {
            parent: 'modelosdeimpresora',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descripcion: null,
                                protocolo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('modelosdeimpresora');
                });
            }]
        })
        .state('modelosdeimpresora.edit', {
            parent: 'modelosdeimpresora',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modelosdeimpresora.delete', {
            parent: 'modelosdeimpresora',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-delete-dialog.html',
                    controller: 'ModelosdeimpresoraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
